module.exports = __webpack_public_path__ + "img/24.b66085e8.jpg";